import { Program, web3 } from "@project-serum/anchor";
import { ConnectionContext } from "../contexts/ConnectionProviderContext";
import TweetsContainer from "../utils/TweetsContainer";
import React, {
  ChangeEvent,
  FC,
  useContext,
  useEffect,
  useState,
} from "react";
import { TweeterDapp } from "../types/tweeter_dapp";
import { useWallet } from "@solana/wallet-adapter-react";
import { TweetsContext } from "../contexts/TweetsContext";
import { LikeContext } from "../contexts/LikesContext";
import { TweetsInfo } from "../utils/TweetsLikes";
import Footer from "./Footer";

const Home: FC = () => {
  const [chars, setChars] = useState<Number>(280);
  const [tweet, setTweet] = useState<string>("");
  const [topic, setTopic] = useState<string>("");
  const [postButton, setPostButton] = useState<string>("Post");
  const {allTweets} = useContext(TweetsContext);
  const { userLikes,setFetch, allLikes}: any = useContext(LikeContext);

  const { workSpace }: any = useContext(ConnectionContext);
  
  const program = workSpace.program as Program<TweeterDapp>;
  const wallet = workSpace.wallet;
  const connection = workSpace.connection;
  const userWallet = useWallet();
  const tweetAccount = web3.Keypair.generate();

 
  const tweetHandler = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const tweet = e.target.value;
    setTweet(tweet);
    const remainingChars = 280 - tweet.length;
    setChars(remainingChars);
  };

  const topicHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const topic = e.target.value;
    setTopic(topic);
  };


  const tweetButtonHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    setPostButton("🚀")
    if (wallet.publicKey.toString() !== userWallet.publicKey?.toString()) {
      alert("Connect your wallet to tweet!");
      setPostButton("Post");
      return;
    }

    if (!tweet) {
      alert("Write something first!");
      setPostButton("Post");
      return;
    }

    if(userWallet) {
      try {
        
        const balance = await connection.getBalance(userWallet.publicKey);
        const balanceInSol = balance && balance / web3.LAMPORTS_PER_SOL;
        if(balanceInSol < 0.001) {
          alert(` Your wallet balance is low - ${balanceInSol}. "AIRDROP" some SOL from here 👉 - https://solfaucet.com/ .`);
          setPostButton("Post");
          return;
        }
      } catch (error) {
        alert("Devnet connection unstable. Please try again.");
        console.log("Error",error);
      setPostButton("Post");
        return;
      }
    }

    try {
      await program.methods.sendTweet(topic, tweet).accounts({
        tweet: tweetAccount.publicKey,
        author: wallet.publicKey,
        systemProgram: web3.SystemProgram.programId
    }).signers([tweetAccount]).rpc();
    
      setChars(280);
      setTopic("");
      setTweet("");
      setPostButton("Post");
      setFetch();
    } catch (error) {
      console.log("Error in Home", error);
      setPostButton("Post");
      alert("Something went wrong!");
      return;
    }

  };


  return (
    <main className="pt-5 gap-4 col-start-3 col-span-12 px-2 md:row-start-7 md:col-start-3 md:col-span-7 md:pt-8 xl:col-start-5 xl:col-span-4">
      <>
      
    {/* <main className=" pt-5 grid grid-cols-12 auto-rows-auto gap-4"> */}
      <h1 className="text-center pb-2 font-medium text-lg">Home Page</h1>
      <form onSubmit={tweetButtonHandler} className="place-self-center rounded-md border-2 border-gray-300 px-4 py-2">
        <textarea
          onChange={tweetHandler}
          placeholder="What's Happening?"
          maxLength={280}
          value={tweet}
          name="tweet"
          className="bg-gray-100 p-2 w-full h-24 md:h-32 focus:outline-none rounded-2xl text-sm md:text-base"
        ></textarea>
        <p className="text-end m-0 text-sm md:text-base">
          <b className="text-rose-500">{chars.toString()}</b> left
        </p>
        <fieldset className="mb-2 flex justify-between items-baseline">
          <input
            onChange={topicHandler}
            className="bg-gray-100 w-40 p-2 m-1 focus:outline-none rounded-2xl text-sm md:text-base sm:w-60"
            type="text"
            placeholder="# topic eg. football"
            name="topic"
            value={topic}
          ></input>
          <div className="space-x-2">
            <button
            disabled={postButton === "🚀" && true}
              onClick={tweetButtonHandler}
              className="bg-blue-400 text-white p-2 font-medium hover:bg-blue-500 rounded-md w-20 text-sm md:text-base"
              type="submit"
            >
              {postButton}
            </button>
          </div>
        </fieldset>
      </form>

    <TweetsContainer tweets = {allTweets} homePage = {true}/>
    </>
      <Footer></Footer>
    </main>
  );
};

export default Home;
